import { AddressService } from '@data';
import { Address } from '@types';

import { SearchFieldQldDS } from '..';
import { SearchFieldProps } from '../searchField/SearchField';

/**
 * Type definition for AddressFieldProps
 * Omitting 'searchFunction' and 'handleChange' from SearchFieldProps
 * Optional handleChange function that takes an Address value
 * 'searchFunction' is straightly passed to SearchField component
 */
type AddressFieldProps = Omit<SearchFieldProps, 'searchFunction' | 'handleChange'> & {
	handleChange?: (value: Address) => void;
};

/**
 * AddressField component is an extension of a search field which lets users type in
 * an address and displays a dropdown list of found addresses which can be selected
 * @param {AddressFieldProps} Prop
 * @returns {Address} The found, selected address
 */
export const AddressField = (props: AddressFieldProps) => {
	const searchAddress = async (searchTerm: string) => {
		return await AddressService.search(searchTerm);
	};

	const onSelectRawAddress = async (rawAddress: string) => {
		if (props.handleChange) {
			const finalAddress = await AddressService.parseToValidAddress(rawAddress);
			props.handleChange(finalAddress);
			return finalAddress;
		}
	};

	return (
		<SearchFieldQldDS {...props} searchFunction={searchAddress} handleChange={onSelectRawAddress} />
	);
};
